module.exports = __webpack_public_path__ + "img/stempel.9ab84860.png";